<div class="grid">
  <div class="col-12">
    <div class="recuadro-widget" style="width: 100%">
      <span class="recuadro-widget-icon bg-green"><i class="fa fa-list-alt"></i></span>

      <div class="recuadro-widget-content">
        <span class="recuadro-widget-number">{{contador}}</span>
        <span class="recuadro-widget-text">{{'WIDGETMODAL.LBL_DESCRIPTERSHI' | translate}}</span>

        <div style="display: flex;">
          <button style="width: 100%; font-size: 12px;" icon="fa fa-arrow-up" class="p-button p-widget p-state-default p-corner-all p-button-text-only text-center"  label="{{ 'BTN_ACTUALIZAR' | translate}}"
                  type="button" (click)="cargarContador()" *ngIf="!loading"
                  pButton ></button>
          <button class="p-button p-widget p-state-default p-corner-all p-button-text-only"
                  label="{{'WIDGETS.BTN_VERMAS' | translate }}"
                  style="width: 100%; margin-left: 10px; font-size: 12px; background-color: #F04505;" *ngIf="!loading"
                  icon="fa fa-plus"
                  type="button"
                  pButton (click)="visualizarIntegracionesFallidas()"></button>
          <div class="col-12 text-center" *ngIf="loading">
            <i class="fa fa-refresh fa-spin"></i>  <span><strong>{{'LBL_PROCESANDO' | translate }}</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="{{'WIDGETMODAL.LBL_TITULOTERSHI' | translate}}" [(visible)]="showModalSolicitudes"
          *ngIf="showModalSolicitudes" [draggable]="false" [resizable]="false"
          [positionTop]="60" [contentStyle]="{'width':'1200px', 'overflow-y': 'auto'}" responsive="true" modal="true">

  <div class="grid">
    <div class="col-12">
      <button class="p-button p-widget p-state-default p-corner-all p-button-text-only excepcion-button" label="{{'WIDGETMODAL.BTN_ENVIAR' | translate }}"
              type="button" (click)="enviarIntegraciones()" *ngIf="listSolicitudes.length>0"
              pButton></button>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 container-integraciones">
      <p-table [value]="listSolicitudes" [columns]="columnas" [paginator]="true" [rows]="10" [loading]="cargandoTabla" paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="text-center">{{row.fechaEjecucion | date:'dd/MM/yyyy HH:mm'}}</td>
            <td class="text-center">{{row.numeroDocumento}}</td>
            <td>{{row.errorIntegracion}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button btn" icon="fa fa-refresh" data-toggle="tooltip"
                        pButton (click)="relanzar(row)" title="{{'WIDGETMODAL.BTN_RELANZAR' | translate}}"></button>
                <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                        pButton (click)="eliminar(row)" title="{{'WIDGETMODAL.BTN_INHABILITAR' | translate}}"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="col-12 text-center" style="margin-top: 20px;">
    <button label="{{'BTN_CANCELAR' | translate }}" pButton class="p-button-secondary p-button-outlined"
            style="color: #009638; border-color: #009638;"
            (click)="showModalSolicitudes=false"></button>
  </div>
</p-dialog>

<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [closeOnEscape]="false" [positionTop]="60"
          [(visible)]="modalVerificacion.verificando" *ngIf="modalVerificacion.verificando"
          [contentStyle]="{'width':'600px'}"
          header="{{ (modalVerificacion.individual ? 'WIDGETMODAL.LBL_TITULOMODALVERIFICADOINDIVIDUAL' : 'WIDGETMODAL.LBL_TITULOMODALVERIFICADO') | translate }}"
          [modal]="true">
  <!-- Vista para mostrar la verificacion del archivo -->
  <div *ngIf="modalVerificacion.estActual === 'INIT'" class="col-12 text-center">
    <div class="col-12 text-center">
      <img src="assets/images/preaprobados/loading.gif" alt=""/>
    </div>
    <div class="col-12 text-center">
      <span>{{ (modalVerificacion.individual ? 'WIDGETMODAL.LBL_VERIFICACIONINDIVIDUAL' : 'WIDGETMODAL.LBL_VERIFICACIONENCURSO') | translate }}</span>
    </div>
    <div class="col-12 text-center" *ngIf="!modalVerificacion.individual">
      <span style="color: #009638">{{excelAvance.avance ? utilitiesService.obtenerPlazoCorrecto(excelAvance.avance* 100) : 0}}% </span>
    </div>
  </div>
  <!-- Vista para mostrar errores -->
  <div *ngIf="modalVerificacion.estActual === 'FINVER' && modalVerificacion.error" class="col-12">
    <div class="col-12 text-center">
      <i class="fa fa-times-circle-o" style="color:red; font-size: 30px"></i>
    </div>
    <div class="col-12 text-center">
      <span>({{excelAvance.errores.length}}) {{ 'MODALCARGAARCHIVO.LBL_ERRORESENCONTRADOS' | translate }}</span>
    </div>
    <div class="col-12" style="max-height: 150px; overflow:auto;">
      <ol>
        <li *ngFor="let error of excelAvance.errores">
          <span class="badge">{{error}}</span>
        </li>
      </ol>
    </div>
  </div>
  <!-- Vista para mostrar el archivo verificado correctamente -->
  <div *ngIf="modalVerificacion.estActual === 'FINVER' && !modalVerificacion.error" class="col-12 text-center">
    <div class="col-12">
      <strong>{{ 'MODALCARGAARCHIVO.LBL_EXITO' | translate }}</strong>
    </div>
    <div class="col-12">
      <img class="img-comprobados" src="assets/images/preaprobados/icons8-comprobado.gif" alt=""/>
    </div>
    <div class="col-12">
      <span>{{ 'WIDGETMODAL.LBL_VERIFICACIONCOMPLETADA' | translate }}</span>
    </div>
  </div>
  <div class="col-12 form-footer-buttons">
    <div class="form-group col-12">
      <button *ngIf="modalVerificacion.estActual !== 'INIT'" label="{{ 'MODALCARGAARCHIVO.BTN_CERRAR' | translate }}" pButton
              class="p-button-secondary btns-acciones" (click)="cerrarVerificacion(modalVerificacion.individual)"></button>
    </div>
  </div>
</p-dialog>

<p-confirmDialog #cd key="eliminar-rotativo-widget" appendTo="body">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
